import { render, staticRenderFns } from "./action-settings.vue?vue&type=template&id=d6071408&scoped=true"
import script from "./action-settings.vue?vue&type=script&lang=js"
export * from "./action-settings.vue?vue&type=script&lang=js"
import style0 from "./action-settings.vue?vue&type=style&index=0&id=d6071408&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6071408",
  null
  
)

export default component.exports